import { render, staticRenderFns } from "./exam-info.vue?vue&type=template&id=0abdbab5&scoped=true&"
import script from "./exam-info.vue?vue&type=script&lang=js&"
export * from "./exam-info.vue?vue&type=script&lang=js&"
import style0 from "./exam-info.vue?vue&type=style&index=0&id=0abdbab5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abdbab5",
  null
  
)

export default component.exports